import { gql } from "@apollo/client";

export const CNC_ACTIONS = gql`
  query cncActions($account_uuid: String!) {
    cnc_actions(account_uuid: $account_uuid) {
      id
      action_id
      action_definition_name
      subject_id
      subject_name
      display_name
      cron
      next_run_time
      enabled
      params
    }
  }
`;

export const CNC_UPDATE_ACTION = gql`
  mutation UpdateAction(
    $account_uuid: String
    $action_id: String!
    $cron: String
    $enabled: Boolean
  ) {
    cnc_update_action(
      account_uuid: $account_uuid
      action_id: $action_id
      cron: $cron
      enabled: $enabled
    ) {
      action {
        id
        enabled
      }
    }
  }
`;

export const CNC_LAUNCH_ACTION = gql`
  mutation cncLaunchAction(
    $account_uuid: String!
    $action_id: String!
    $notify_progress: Boolean
    $params_override: JSONString
  ) {
    cnc_action_launcher(
      account_uuid: $account_uuid
      action_id_: $action_id
      notify_progress: $notify_progress
      launch_sync: true
      params_override: $params_override
    ) {
      task_id
      launched_tasks
    }
  }
`;

export interface launchActionMutationVariablesType {
  account_uuid: string;
  action_id: string;
  notify_progress?: boolean;
  params_override?: string;
}

export interface launchActionMutationOptionsType {
  variables: launchActionMutationVariablesType;
}

export interface launchActionDataType {
  cnc_action_launcher?: {
    task_id?: string;
    launched_tasks?: string;
  };
}

export interface launchActionMutationResponseType {
  data?: launchActionDataType;
}
